import * as React from 'react';
import { createFileRoute } from '@tanstack/react-router';
import { CloudDashboardPreviewShell } from '@/page/dashboard/components/dashboard-preview-shell';
import { DemoObserveDashboard } from '@/page/dashboard/components/demo-observe-dashboard';
import s from './demo.module.scss';

// Standalone, unauthenticated dashboard for pitch-deck screenshots. Renders the
// real Cloud chrome (CloudDashboardPreviewShell — no Convex/Clerk hooks) around
// static demo content, forced to the dark theme. Lives outside `_authed`, so it
// never triggers the auth/onboarding redirects.

export const Route = createFileRoute('/demo')({
  component: DemoDashboardPage,
  head: () => ({
    meta: [
      { title: 'Fragments Cloud — Dashboard' },
      { name: 'robots', content: 'noindex, nofollow' },
    ],
  }),
});

function DemoDashboardPage() {
  useForceDarkTheme();

  return (
    <div className={s.viewport}>
      <CloudDashboardPreviewShell
        activeNav="Dashboard"
        projectLabel="Acme Design System"
        projectMeta="acme · Pro plan"
        accountName="Conan McNicholl"
        accountEmail="conan@usefragments.com"
        avatarLabel="C"
        showAccount
      >
        <DemoObserveDashboard />
      </CloudDashboardPreviewShell>
    </div>
  );
}

// Force dark theme for this route regardless of the visitor's system setting,
// then restore the prior value on unmount. The token set is scoped to
// :root[data-theme='dark'], so the attribute has to live on <html>.
function useForceDarkTheme() {
  React.useEffect(() => {
    const root = document.documentElement;
    const prevTheme = root.getAttribute('data-theme');
    const prevColorScheme = root.style.colorScheme;
    root.setAttribute('data-theme', 'dark');
    root.style.colorScheme = 'dark';
    return () => {
      if (prevTheme === null) {
        root.removeAttribute('data-theme');
      } else {
        root.setAttribute('data-theme', prevTheme);
      }
      root.style.colorScheme = prevColorScheme;
    };
  }, []);
}
